import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import de from "./locales/de.json";

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    lng: "en", // Set default language to English
    // lng: "de", // Set default language to german
    fallbackLng: "en", // Use English if detected language is not available
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
